export default __webpack_public_path__ + "static/media/pop-up-banner.78b4efa1.png";